import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import {
    programSetActiveSelection,
    selectionsDisplayAddItem,
} from '../../actions'
import toJS from '../../hoc/toJS'
import AddNewSection from '../../components/forms/AddNewSection'
import { PROGRAM_CLI_MOVIES_ITEMS, PROGRAM_SELECTIONSDISPLAY_ITEMS, PROGRAM_CINEMAS, CLI_CINEMA_CLIENT_ID, PROGRAM_SELECTIONSDISPLAY_ORDER, PROGRAM_ATTRIBUTES_GLOBAL, UI_PROGRAM, PROGRAM_ATTRIBUTES, FEATURES, WPSERVER } from '../../constants/state'
import getData from '../../functions/getData'


const currentLangToProps = state => ({
    currentLang: state.getIn(['translation', 'currentLang'])
})


const mapStateToProps = (state, ownProps) => ({
    activeSelection:                    getData(state, [UI_PROGRAM, 'activeSelection']),
    [PROGRAM_SELECTIONSDISPLAY_ITEMS]:  getData(state, PROGRAM_SELECTIONSDISPLAY_ITEMS),
    [PROGRAM_SELECTIONSDISPLAY_ORDER]:  getData(state, PROGRAM_SELECTIONSDISPLAY_ORDER),
    movieData:                          getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    attributes:                         getData(state, PROGRAM_ATTRIBUTES),
    allGenres:                          getData(state, [PROGRAM_ATTRIBUTES_GLOBAL, 'genres']),
    features:                           getData(state, FEATURES),
    serverData:                         state.getIn(['wpServerData']),
    sectionEnterTitleString:            state.getIn(['translation', 'strings', 'section_enter_title', ownProps.currentLang]),
    clientCinemaId:                     getData(state, CLI_CINEMA_CLIENT_ID),
    cliCinemas:                         getData(state, PROGRAM_CINEMAS),
})


const mapDispatchToProps = (dispatch, ownProps) => ({
    collapseActiveSelection: (activeClass) => {
        const activeSelectionsID = activeClass === "accordion-item-open" ? '' : ownProps.type
        dispatch(programSetActiveSelection(activeSelectionsID))
    },

    
    addDisplaySelection: (values) => {
        dispatch(selectionsDisplayAddItem(values))
    }
})


const AddNewSectionContainer = ({activeSelection, type, movieData, clientCinemaId, cliCinemas, collapseActiveSelection, addDisplaySelection, attributes, allGenres, features, serverData, sectionEnterTitleString}) => {    
    const selectionActiveClass = activeSelection === type ? "accordion-item-open" : "accordion-item-close"
    let technicalAttributesArr = {}
    const hasShowtimes = serverData.data && serverData.data.data && serverData.data.data.front ? serverData.data.data.front.has_showtimes_feature  : null
    const hasAdvertisements = serverData.data && serverData.data.data && serverData.data.data.routes ? serverData.data.data.routes.advertisement  : null

    _.keys(attributes).map(attributeCinemaKey => { 
        const technicalAttributesList = attributes[attributeCinemaKey].technical
        _.keys(technicalAttributesList).map(technicalAttributesListKey => {
            const technicalAttribute = technicalAttributesList[technicalAttributesListKey]

            if(!_.findKey(technicalAttributesArr, technicalAttribute.name)) {
                technicalAttributesArr[technicalAttribute.name] = technicalAttribute
            }
        })
    })

    return (
        <AddNewSection
            type={type}
            hasShowtimes={hasShowtimes}
            hasAdvertisements={hasAdvertisements}
            data={movieData}
            selectionActiveClass={selectionActiveClass}
            allGenres={allGenres}
            technicalAttributes={technicalAttributesArr}
            clientCinemaId={clientCinemaId}
            cliCinemas={cliCinemas}
            collapseActiveSelection={collapseActiveSelection}
            addDisplaySelection={addDisplaySelection}
            features={features}
            sectionEnterTitleString={sectionEnterTitleString}
        />
    )
}


export default compose(
    connect(currentLangToProps, null),
    connect(mapStateToProps, null),
    connect(null, mapDispatchToProps),
    toJS()
)(AddNewSectionContainer)

